/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../../../types/definitions/vendor/graphql-schema.d";
import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type VisionShareRecordCreateMutationVariables = Types.Exact<{
  input: Types.VisionShareRecordCreateInput;
}>;
export type VisionShareRecordCreateMutation = {
  __typename?: "Mutation";
  visionShareRecordCreate?: {
    __typename?: "VisionShareRecordCreatePayload";
    result: {
      __typename?: "VisionShareRecordCreateError";
      message: string;
    } | {
      __typename?: "VisionShareRecordCreateSuccess";
      shareUrl: string;
    };
  } | null;
};
export const VisionShareRecordCreateDocument = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "mutation",
    name: {
      kind: "Name",
      value: "visionShareRecordCreate"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "input"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "VisionShareRecordCreateInput"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "visionShareRecordCreate"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "input"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "input"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "result"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "InlineFragment",
                typeCondition: {
                  kind: "NamedType",
                  name: {
                    kind: "Name",
                    value: "VisionShareRecordCreateSuccess"
                  }
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "shareUrl"
                    }
                  }]
                }
              }, {
                kind: "InlineFragment",
                typeCondition: {
                  kind: "NamedType",
                  name: {
                    kind: "Name",
                    value: "VisionShareRecordCreateError"
                  }
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "message"
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;
export type VisionShareRecordCreateMutationFn = Apollo.MutationFunction<VisionShareRecordCreateMutation, VisionShareRecordCreateMutationVariables>;

/**
 * __useVisionShareRecordCreateMutation__
 *
 * To run a mutation, you first call `useVisionShareRecordCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVisionShareRecordCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [visionShareRecordCreateMutation, { data, loading, error }] = useVisionShareRecordCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVisionShareRecordCreateMutation(baseOptions?: Apollo.MutationHookOptions<VisionShareRecordCreateMutation, VisionShareRecordCreateMutationVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useMutation<VisionShareRecordCreateMutation, VisionShareRecordCreateMutationVariables>(VisionShareRecordCreateDocument, options);
}
export type VisionShareRecordCreateMutationHookResult = ReturnType<typeof useVisionShareRecordCreateMutation>;
export type VisionShareRecordCreateMutationResult = Apollo.MutationResult<VisionShareRecordCreateMutation>;
export type VisionShareRecordCreateMutationOptions = Apollo.BaseMutationOptions<VisionShareRecordCreateMutation, VisionShareRecordCreateMutationVariables>;